module.exports = __webpack_public_path__ + "img/9788958072553.4d17a001.jpg";